import { Request } from '../base/Request';
import { Method } from 'axios';

export default class GetMediaclipProjectIdentifierRequest extends Request<string> {
  private projectId: string = '';

  protected getEndPoint(): string {
    return `${window.base_url}rest/V1/canvascompany/product-configurator/get-mediaclip-project-identifier/${this.projectId}`;
  }

  protected getMethod(): Method {
    return 'GET';
  }

  setProjectId(value: string): this {
    this.projectId = value;
    return this;
  }
}
